/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Apple = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Apple"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      d="M15.598 6.83q-.745 0-1.392.233-.636.232-1.162.465-.527.222-.915.222-.407 0-.904-.212a17 17 0 0 0-1.073-.434 3.4 3.4 0 0 0-1.213-.213q-1.222 0-2.355.677-1.133.678-1.859 2.001Q4 10.893 4 12.834q0 1.212.278 2.425.279 1.213.746 2.294.467 1.082 1.033 1.91.735 1.04 1.431 1.79.705.747 1.63.747a2.5 2.5 0 0 0 1.053-.202q.448-.203.945-.414.506-.203 1.262-.203.576 0 .964.122.387.12.705.273.328.161.686.282.358.122.864.122a2.05 2.05 0 0 0 1.193-.364 4.2 4.2 0 0 0 .984-.92q.458-.566.884-1.182.467-.698.756-1.334.297-.647.437-1.051.139-.414.149-.455-.03-.01-.437-.222-.398-.222-.915-.698-.506-.474-.894-1.243-.378-.768-.378-1.88 0-.97.298-1.667.308-.708.716-1.162.408-.465.726-.708.327-.242.377-.272-.496-.728-1.083-1.132a4.4 4.4 0 0 0-1.153-.586 4.8 4.8 0 0 0-1.014-.223 6 6 0 0 0-.645-.05m-.696-1.636q.457-.556.745-1.284.288-.738.288-1.516 0-.223-.03-.394-.744.03-1.56.455-.804.424-1.331 1.06a4.8 4.8 0 0 0-.756 1.214 3.6 3.6 0 0 0-.328 1.495q0 .121.01.223l.03.141q.13.03.268.03.666 0 1.412-.404.754-.405 1.252-1.02"
      className="SVG"
    />
  </svg>
);

export const AppleIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'apple-icon'}
      icon={Apple}
      {...props}
      size={size}
    />
  );
};
